import { Action, CLOSE_MODAL, OPEN_MODAL } from './actions';
import { initialState, ModalsType } from './types';

export const reducer = (state: ModalsType = initialState, action: Action): ModalsType => {
  switch (action.type) {
    case OPEN_MODAL:
      return {
        ...state,
        modalType: action.modalType,
        params: action.params,
        isOpen: true,
      };
    case CLOSE_MODAL:
      return {
        ...state,
        isOpen: false
      };
    default:
      return state;
  }
};
